import { useTranslation } from "react-i18next";

import DgdocUpload from "./DgBooking/dgdoc-upload";
import { CustomPopup } from "../../common/Popup/CustomPopup";
import pdf from "../../assets/images/pdf.png";
import excel from "../../assets/images/excel.png";
import word from "../../assets/images/word.png";
import walpaper from "../../assets/images/walpaper.png";
import document from "../../assets/images/document.png";
import infoicon from "../../../src/assets/images/infoicon.png";
import "./search-panel.scss";

const DgFileUpload = ({ dgarrayListDoc, handelPopup, displayDglist, closeDialog, file, handleRemovedg, fileName, setDisplayUploadSection, onCommodityChange, setOnCommodityChange, unid, setUnid, setFile, searchFormData, setIsLoading }) => {

	const { t } = useTranslation(["labels", "errors"]);

	return(<div className="dg-doc-upload-session">
		<label className="upload-main-head">
			{t("COMMON.DG_DOCUMENTS")}
		</label>
		<div className="dg-upload-body">
			<div className="upload-doc-label-info">
				<label className="upload-doc-label">
					{dgarrayListDoc.length > 0
						? `${t("COMMON.FILE_DG_UPLOADED")}`
						: `${t("COMMON.UPLOAD_RELEVANT")}`}
				</label>
				<img
					src={infoicon}
					onClick={handelPopup}
					alt="Allowed list"
					title="Allowed list"
					className="upload-doc-icon"
				/>
			</div>

			<CustomPopup
				isVisible={displayDglist}
				footerPriBtnLabel={t("COMMON.OK")}
				footerPriBtnClick={closeDialog}
				headerComponent={{
					mainHeader: t("COMMON.DOC_REQUIRED"),
				}}
				onClose={closeDialog}
				body={
					<ul
						className="ml-4"
						style={{ listStyle: "disc" }}
					>
						<li>{t("BOOKING.DG_LABEL")}</li>
						<li>{t("BOOKING.LICPER_LABEL")}</li>
					</ul>
				}
			/>
			{(file?.length > 0 ||
				dgarrayListDoc?.length > 0) && (
					<ul className="dg-up-file-list">
						{dgarrayListDoc?.map((element, i) => {
							const filArraypath =
								element?.fileName?.split(".");
							return (
								<li className="dg-up-file">
									<div
										className="up-file-details"
										key={i}
									>
										<img
											src={
												filArraypath &&
													filArraypath[1] === "pdf"
													? pdf
													: (filArraypath &&
														filArraypath[1] ===
														"xlsx") ||
														(filArraypath &&
															filArraypath[1] === "xls")
														? excel
														: filArraypath &&
															filArraypath[1] === "docx"
															? word
															: (filArraypath &&
																filArraypath[1] ===
																"png") ||
																(filArraypath &&
																	filArraypath[1] ===
																	"jpeg") ||
																(filArraypath &&
																	filArraypath[1] === "jpg")
																? walpaper
																: document
											}
											alt={
												filArraypath && filArraypath[1]
											}
											title={
												filArraypath && filArraypath[1]
											}
										/>
										<span> {element.fileName}</span>
									</div>
									<span
										className="up-file-delete"
										onClick={(e) =>
											handleRemovedg(element, i)
										}
									>
										{t("COMMON.DELETE")}
									</span>
								</li>
							);
						})}
					</ul>
				)}

			<DgdocUpload
				id={"dgUpload"}
				setDisplayUploadSection={
					setDisplayUploadSection
				}
				fileName={fileName}
				onCommodityChange={onCommodityChange}
				setOnCommodityChange={setOnCommodityChange}
				file={file}
				unid={unid}
				setUnid={setUnid}
				setFile={setFile}
				fileCount={dgarrayListDoc[0] ? true : false}
				dgarrayListDoc={dgarrayListDoc}
				searchFormData={searchFormData}
				setIsLoading={setIsLoading}
			/>
		</div>
	</div>
	)
}

export default DgFileUpload;